import React, { useEffect, useRef, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import { Link } from 'react-router-dom';
import { API_URL } from '..';
import Swal from 'sweetalert2';
import Select from 'react-select';
import { Modal, Button } from 'react-bootstrap';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1IjoiemFtcCIsImEiOiJjbTkxa3dkcnMwMmQxMnJzYzBobW9hOHBiIn0.GWvvqPrWqtMby0HYCYdjMQ';

function formatDateString(dateStr) {
  const date = new Date(dateStr);
  const options = { day: '2-digit', month: 'short', year: 'numeric' };
  return date.toLocaleDateString('en-GB', options);
}

const QuoteListLayer = ({ jobsData }) => {
  const mapContainerStyle = {
    width: '100%',
    height: '400px',
    borderRadius: '8px',
    border: '1px solid #ced4da',
  };
  const defaultCenter = {
    lat: 51.5074,
    lng: -0.1276,
  };
  const navigate = useNavigate();
  const [postCode, setPostCode] = useState('');
  const [currentUser, setCurrentUser] = useState({});
  const [createJob, setCreateJob] = useState(false);
  const [selectedElectricians, setSelectedElectricians] = useState([]);
  const [selectedWorkforceIds, setSelectedWorkforceIds] = useState([]);
  const [errors, setErrors] = useState({});
  const [jobDescription, setJobDescription] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalQuoteId, setModalQuoteId] = useState(null);
  const [enableGeofencing, setEnableGeofencing] = useState(false);
  const [radius, setRadius] = useState(100);
  const [isJobLocationCustomerAddress, setIsJobLocationCustomerAddress] = useState(true);
  const [jobLocation, setJobLocation] = useState('');
  const [jobLocationCoordinates, setJobLocationCoordinates] = useState(null);
  const [jobLocationSuggestions, setJobLocationSuggestions] = useState([]);
  const jobDescriptionQuillRef = useRef(null);
  const jobDescriptionQuillInstance = useRef(null);
  const jobLocationInputRef = useRef(null);

  // Memoize privileges to prevent re-creation on every render
  const privileges = useMemo(() => {
    const storedPrivileges = localStorage.getItem('privilages');
    return storedPrivileges
      ? JSON.parse(storedPrivileges)
      : { quotes: { edit: false, delete: false, read: false, changeStatus: false } };
  }, []);

  const fetchCoordinates = async (address) => {
    if (!address) return { latitude: '', longitude: '' };
    try {
      const response = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
          address
        )}.json?access_token=${MAPBOX_ACCESS_TOKEN}&country=GB&limit=1`
      );
      const data = await response.json();
      if (data.features?.length > 0) {
        const [longitude, latitude] = data.features[0].geometry.coordinates;
        return { latitude, longitude };
      }
      return { latitude: '', longitude: '' };
    } catch (error) {
      console.error('Error fetching coordinates:', error);
      return { latitude: '', longitude: '' };
    }
  };
  const getActionsColumn = (data, type, row) => {
    if (currentUser?.roles?.role === 'user') {
      // For users, show actions based on privileges
      const actions = [];
      if (privileges?.quotes?.read) {
        actions.push(
          `<li><a style="cursor:pointer" class="dropdown-item view-btn" data-id="${row.id}"><i class="ph ph-eye"></i> View Quote</a></li>`
        );
      }
      if (privileges?.quotes?.edit) {
        actions.push(
          `<li><a style="cursor:pointer" class="dropdown-item edit-btn" data-id="${row.id}"><i class="ph ph-pencil"></i> Edit Quote</a></li>`
        );
      }
      if (privileges?.quotes?.delete) {
        actions.push(
          `<li><a style="cursor:pointer" class="dropdown-item delete-btn" data-id="${row.id}"><i class="ph ph-trash"></i> Delete Quote</a></li>`
        );
      }
      if (privileges?.quotes?.changeStatus) {
        actions.push(
          `<li><a style="cursor:pointer" class="dropdown-item make-btn" data-id="${row.id}"><i class="ph ph-eye"></i> Make it Invoice</a></li>`
        );
      }
      if (actions.length === 0) {
        return '<span>No actions available</span>';
      }
      return `
        <div class="dropdown">
          <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="ph ph-list"></i>
          </button>
          <ul class="dropdown-menu">
            ${actions.join('')}
          </ul>
        </div>
      `;
    } else {
      // For admins or other roles, show all actions
      return `
        <div class="dropdown">
          <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="ph ph-list"></i>
          </button>
          <ul class="dropdown-menu">
            <li><a style="cursor:pointer" class="dropdown-item make-btn" data-id="${row.id}"><i class="ph ph-eye"></i> Make it Invoice</a></li>
            <li><a style="cursor:pointer" class="dropdown-item view-btn" data-id="${row.id}"><i class="ph ph-eye"></i> View Quote</a></li>
            <li><a style="cursor:pointer" class="dropdown-item edit-btn" data-id="${row.id}"><i class="ph ph-pencil"></i> Edit Quote</a></li>
            <li><a style="cursor:pointer" class="dropdown-item delete-btn" data-id="${row.id}"><i class="ph ph-trash"></i> Delete Quote</a></li>
          </ul>
        </div>
      `;
    }
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      navigate('/sign-in');
      return;
    }
    setCurrentUser(user);

    // Define the actions column based on user role and privileges
  
    const table = $('#dataTable').DataTable({
      data: jobsData,
      responsive: true,
      pageLength: 10,
      order: [[0, 'desc']],
      columns: [
        { data: 'id' },
        { data: 'customer_name' },
        { data: 'phone' },
        {
          data: 'issue_date',
          render: function (data, type, row) {
            return `<span>${formatDateString(data)}</span>`;
          },
        },
        {
          data: 'amount',
          render: function (data, type, row) {
            return `<span>${row.currency} ${parseFloat(data).toFixed(2)}</span>`;
          },
        },
        {
          data: null,
          render: getActionsColumn,
          title: 'Actions',
          orderable: false,
        },
      ],
    });

    $('#dataTable tbody').on('click', '.edit-btn', function () {
      const id = $(this).data('id');
      navigate(`/quote-edit/${id}`);
    });

    $('#dataTable tbody').on('click', '.view-btn', function () {
      const id = $(this).data('id');
      navigate(`/quote-preview/${id}`);
    });

    $('#dataTable tbody').on('click', '.delete-btn', function () {
      const id = $(this).data('id');
      handleDelete(id);
    });

    $('#dataTable tbody').on('click', '.make-btn', function () {
      const id = $(this).data('id');
      handleMakeIt(id);
    });

    return () => {
      table.destroy(true);
    };
  }, [1]);

  // Address suggestions for job location
  const handleDelete = async (id) => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      navigate('/sign-in');
      return;
    }
    try {
      let headersList = {
        Accept: '*/*',
        'Content-Type': 'application/json',
      };
      let response = await fetch(`${API_URL}/api/invoice/delete-invoice/${id}`, {
        method: 'DELETE',
        headers: headersList,
      });
      let data = await response.json();
      if (data.message === 'Invoice deleted successfully') {
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Quote deleted successfully!',
        });
        window.location.reload();
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: data.message || 'Failed to delete quote',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to delete quote: ' + error.message,
      });
    }
  };

  const handleMakeIt = (id) => {
    const quote = jobsData.find((job) => job.id === id);
    if (!quote) {
      if (quote === undefined) {
        setShowModal(false);
        return;
      }
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Quote not found',
      });
      return;
    }
    setModalQuoteId(id);
    setCreateJob(false);
    setSelectedElectricians([]);
    setSelectedWorkforceIds([]);
    setErrors({});
    setJobDescription('');
    setIsJobLocationCustomerAddress(true);
    setJobLocation('');
    setJobLocationCoordinates(null);
    setJobLocationSuggestions([]);
    setEnableGeofencing(false);
    setRadius(100);
    setShowModal(true);
  };

  const handleJobLocationSelect = (selected) => {
    if (selected) {
      setJobLocation(selected.value);
      setJobLocationCoordinates({
        latitude: selected.coordinates[1],
        longitude: selected.coordinates[0],
      });
      setJobLocationSuggestions([]);
      setErrors((prev) => ({ ...prev, jobLocation: null }));
    }
  };

  const handleSubmit = async () => {
    const newErrors = {};
    if (createJob) {
      if (selectedElectricians.length === 0) {
        newErrors.electricians = 'At least one electrician must be selected';
      }
      if (!isJobLocationCustomerAddress && !jobLocation) {
        newErrors.jobLocation = 'Job location is required';
      }
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return;
      }
    }

    try {
      const quote = jobsData.find((job) => job.id === modalQuoteId);
      const user = JSON.parse(localStorage.getItem('user'));
      if (!quote) throw new Error('Quote not found');

      // Convert quote to invoice
      const invoiceResponse = await fetch(`${API_URL}/api/invoice/convert-to-invoice/${modalQuoteId}`, {
        method: 'PUT',
        headers: {
          Accept: '*/*',
          'Content-Type': 'application/json',
        },
      });
      const invoiceData = await invoiceResponse.json();
      if (invoiceData.message !== 'success') {
        throw new Error(invoiceData.message || 'Failed to convert quote to invoice');
      }

      setShowModal(false);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: createJob
          ? 'Quote converted to invoice and job created successfully!'
          : 'Quote converted to invoice successfully!',
      }).then(() => {
        window.location.reload();
      });
    } catch (error) {
      setErrors({ ...errors, submit: error.message });
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'An error occurred',
      });
    }
  };

  return (
    <div className="card basic-data-table">
      <style>
        {`
          .react-select .select__control {
            border: 1px solid #ced4da;
            border-radius: 4px;
            min-height: 38px;
          }
          .react-select.is-invalid .select__control {
            border-color: #dc3545;
          }
          .react-select .select__menu {
            z-index: 1050;
          }
          .ql-container {
            min-height: 150px;
            border-radius: 4px;
            border: 1px solid #ced4da;
          }
          .ql-toolbar {
            border-radius: 4px 4px 0 0;
            background-color: #f8f9fa;
          }
          .ql-editor {
            min-height: 100px;
          }
          .address-suggestions {
            position: absolute;
            z-index: 1000;
            background: white;
            border: 1px solid #ced4da;
            border-radius: 8px;
            width: 100%;
            max-height: 200px;
            overflow-y: auto;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            margin-top: 0.25rem;
          }
          .address-suggestions li {
            padding: 0.75rem;
            cursor: pointer;
            transition: background-color 0.2s ease;
          }
          .address-suggestions li:hover {
            background-color: #f8f9fa;
          }
        `}
      </style>
      <div className="card-header">
        <div className="row">
          <h5 className="col-md-6 card-title mb-0">Quotes</h5>
          <div className="col-md-6 text-end">
            <Link className="btn btn-info" to={'/create-quote'}>
              Add New
            </Link>
          </div>
        </div>
      </div>
      <div className="card-body">
        <table className="table bordered-table mb-0" id="dataTable">
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Customer Name</th>
              <th scope="col">Customer Phone</th>
              <th scope="col">Issued Date</th>
              <th scope="col">Amount</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            {/* DataTables will populate this tbody */}
          </tbody>
        </table>
      </div>

      <Modal size="lg" show={showModal} onHide={handleMakeIt} centered>
        <Modal.Header closeButton>
          <Modal.Title className="h6">Convert Quote to Invoice</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <div className="form-check">
              <label htmlFor="createJob" className="form-check-label">
                Are you sure that you want to convert this into invoice
              </label>
            </div>
          </div>
          {errors.submit && (
            <div className="alert alert-danger">{errors.submit}</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleMakeIt}>
            Not, now
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Yes, sure
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default QuoteListLayer;